/* ==========================================================================
   PRICE DROP — SCROLLING RIBBON (MARQUEE)
   Shared by the Mega Price Drop hero and the Price Drop collection banner.

   Each ribbon holds two identical groups and slides its track by -50%, so one
   full loop covers exactly one group's width. Deriving the duration from that
   measured width keeps every ribbon moving at its px-per-second setting
   whether the viewport is a phone or an ultrawide.
   ========================================================================== */

(function () {
  'use strict';

  var MARQUEE_SELECTOR = '[data-mpd-marquee]';
  var GROUP_SELECTOR = '[data-mpd-marquee-group]';

  function syncSpeed(marquee) {
    var group = marquee.querySelector(GROUP_SELECTOR);
    if (!group) return;

    var speed = parseFloat(marquee.dataset.speed);
    if (!speed || speed <= 0) speed = 80;

    var width = group.getBoundingClientRect().width;
    if (!width) return;

    marquee.style.setProperty('--mpd-marquee-duration', (width / speed).toFixed(2) + 's');
  }

  function initMarquee(marquee) {
    if (!marquee || marquee.dataset.mpdMarqueeReady === 'true') return;
    marquee.dataset.mpdMarqueeReady = 'true';

    syncSpeed(marquee);

    // Web fonts land after first paint and change the measured width
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        syncSpeed(marquee);
      });
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        syncSpeed(marquee);
      }).observe(marquee);
    } else {
      window.addEventListener('resize', function () {
        syncSpeed(marquee);
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll(MARQUEE_SELECTOR).forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();
